import PlanningUpdates, {
  getPlanningUpdatesStaticProps,
} from "../planning-updates.js";
import PlanningApplicationPage, {
  getStaticProps as getPlanningApplicationStaticProps,
} from "../planning-application/[...reference]";
import { getCouncilConfig } from "../../lib/councils";

function normalizeReferenceSegments(value) {
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  if (typeof value !== "string" || !value.trim()) return [];
  return value.split("/").filter(Boolean);
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" };
}

export async function getStaticProps(context) {
  const reference = normalizeReferenceSegments(context.params?.reference);
  const firstSegment = reference[0] || "";
  const lowercaseSegment = firstSegment.toLowerCase();
  const council = getCouncilConfig(lowercaseSegment);

  if (council && !council.publicEnabled) {
    return { notFound: true };
  }

  if (council && firstSegment !== council.shortCode) {
    return {
      redirect: {
        destination: `/planning-updates/${council.shortCode}`,
        permanent: true,
      },
    };
  }

  if (council || lowercaseSegment === 'london') {
    const result = await getPlanningUpdatesStaticProps({
      councilSlug: council?.slug || 'london',
      initialFetchLimit: 30,
      pageSize: 30,
      maxPages: 1,
      preferLightFeed: true,
    });
    return {
      props: {
        ...(result.props || {}),
        routeKind: "planning-updates",
      },
      revalidate: result.revalidate || 600,
    };
  }

  if (/^[a-z]{3,4}$/i.test(firstSegment)) {
    return { notFound: true };
  }

  return getPlanningApplicationStaticProps({
    ...context,
    params: {
      reference,
    },
  });
}

export default function PlanningUpdatesReferenceRoute(props) {
  if (props?.routeKind === "planning-updates") {
    return <PlanningUpdates {...props} />;
  }

  return <PlanningApplicationPage {...props} />;
}
